// Parameters Panel Component
// Organized for Supabase Migration

import React from 'react';

export const ParametersPanel = ({
  currentSketch,
  getCurrentParams,
  updateParameter,
  resetParameters,
  showParameters
}) => {
  if (!showParameters || !currentSketch) return null;

  const currentParams = getCurrentParams();

  return (
    <div className="lg:col-span-1">
      <div className="bg-gray-50 rounded-lg p-4 sticky top-6">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-semibold">Parameters</h3>
          <button
            onClick={resetParameters}
            className="text-xs bg-gray-600 text-white px-3 py-1 rounded hover:bg-gray-700 transition-colors"
          >
            Reset
          </button>
        </div>
        
        <div className="space-y-3 max-h-96 overflow-y-auto">
          {currentSketch.parameter_config?.map((param) => (
            <div key={param.name} className="space-y-1">
              <label className="text-sm font-medium text-gray-700">
                {param.label}
              </label>
              {param.type === 'number' ? (
                <input
                  type="number"
                  value={currentParams[param.name] || 0}
                  onChange={(e) => updateParameter(param.name, parseFloat(e.target.value) || 0)}
                  min={param.min}
                  max={param.max}
                  step={param.step || 1}
                  className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
                />
              ) : param.type === 'color' ? (
                <input
                  type="color"
                  value={currentParams[param.name] || "#000000"}
                  onChange={(e) => updateParameter(param.name, e.target.value)}
                  className="w-full h-10 border border-gray-300 rounded"
                />
              ) : param.type === 'checkbox' ? (
                <input
                  type="checkbox"
                  checked={currentParams[param.name] || false}
                  onChange={(e) => updateParameter(param.name, e.target.checked)}
                  className="w-4 h-4"
                />
              ) : (
                <input
                  type="text"
                  value={currentParams[param.name] || ""}
                  onChange={(e) => updateParameter(param.name, e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded text-sm"
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
